// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c05d4f6e/" + chunkId + "." + __webpack_require__.h() + ".vc05d4f6e.js";
};